export const set = (store, company) => {
  store.state.company = company;
  store.setState({ company });
};

export default set;
